<template>
  <div>
    <vs-button type="border" class="mr-2" @click.stop="activePrompt = true">
      {{ $t('case_manager.edit_price') }}
    </vs-button>
    <vs-popup :title="$t('case_manager.edit_price')" :active.sync="activePrompt">
      <div class="vx-col">
        <label class="vs-input--label">{{ $t('admin.service_subject.unit') }}</label>
        <v-select
          v-model="unit"
          :clearable="false"
          :options="unitOptions"
          :reduce="option => option.value"
          name="unit"
          v-validate="'required'"
          :data-vv-as="$t('admin.service_subject.unit')"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          class="w-full"
        />
        <span class="text-danger text-sm" v-show="errors.has('unit')">
          {{ errors.first('unit') }}
        </span>
      </div>
      <div class="vx-col">
        <label class="vs-input--label">{{ $t('admin.service_subject.price') }}</label>
        <vs-input
          name="price"
          type="number"
          v-validate="'required'"
          :data-vv-as="$t('admin.service_subject.price')"
          class="w-full"
          v-model="price"
          @keyup="price = translateNumbers(price)"
        />
        <span class="text-danger text-sm" v-show="errors.has('price')">
          {{ errors.first('price') }}
        </span>
      </div>
      <div class="vx-col">
        <label class="vs-input--label">{{ $t('invoices.count') }}</label>
        <vs-input
          name="count"
          type="number"
          v-validate="'required'"
          :data-vv-as="$t('invoices.count')"
          class="w-full"
          v-model="count"
          @keyup="count = translateNumbers(count)"
        />
        <span class="text-danger text-sm" v-show="errors.has('count')">
          {{ errors.first('count') }}
        </span>
      </div>
      <vs-row vs-justify="flex-end" class="mt-base">
        <vs-button class="mr-2" @click="activePrompt = false" color="danger" type="border">
          {{ $t('forms.cancel') }}
        </vs-button>
        <vs-button
          id="edit_btn"
          color="success"
          class="vs-con-loading__container mr-2"
          @click="update"
          :disabled="disabled_btn"
        >
          {{ $t('forms.update') }}
        </vs-button>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import { TranslateNumbers } from '@/utils'

export default {
  name: 'EditCaseManagerPrice',
  props: {
    invoice: { type: Object, required: true }
  },
  data() {
    return {
      activePrompt: false,
      disabled_btn: false,
      price: 0,
      count: 1,
      unit: 'time'
    }
  },
  computed: {
    unitOptions() {
      return this.$store.getters['enum/selectOptions']('InvoiceUnit', 'units')
    }
  },
  methods: {
    translateNumbers(val) {
      return TranslateNumbers(val)
    },
    update() {
      this.$store.dispatch('invoice/updateCaseManagerItem', {
        id: this.invoice.id,
        data: { count: this.count, price: this.price, unit: this.unit }
      })
    }
  },
  created() {
    if (this.invoice.items.findIndex(i => i.name === '!health:common:common@case_manager') >= 0) {
      const item = this.invoice.items.find(i => i.name === '!health:common:common@case_manager')
      this.count = item.count
      this.price = item.price
      this.unit = item.unit
    }
  }
}
</script>

<style scoped></style>
